import { render, staticRenderFns } from "./TwoColOverlayed.vue?vue&type=template&id=70c1f5c4&scoped=true&"
import script from "./TwoColOverlayed.vue?vue&type=script&lang=js&"
export * from "./TwoColOverlayed.vue?vue&type=script&lang=js&"
import style0 from "./TwoColOverlayed.vue?vue&type=style&index=0&id=70c1f5c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c1f5c4",
  null
  
)

export default component.exports